import type { KAPLAYCtxT } from 'kaplay'

export default function (k: KAPLAYCtxT) {
  k.loadFont('Jersey10', 'fonts/Jersey10.ttf')
}
